/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */

import React, { useEffect, useRef, useState } from 'react';
import { Breadcrumb, Button, Card, Input, Switch, message, Rate, Badge, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined, MinusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import DrawerDriver from './DrawerDriver';
import {
	changeDriverAllowBookingDecline,
	changeDriverStatus,
	deleteDriver,
	getAllDrivers,
	getDriverById,
} from '../../redux/driverSlice';
import { style } from '../../Styles';
import CustomAvatar from '../Global/CustomAvatar/CustomAvatar';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import { getAllFleetOperators } from '../../redux/fleetOperatorSlice';
import ActionButtonWithChangeStatus from '../Global/ActionButtonWithChangeStatus';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import { CheckDriverEnabled } from '../../Utils/CheckFeatures';

const Driver = ({ isActive }) => {
	const columns = [
		{
			title: 'Profile Picture',
			key: 'profilePicture',
			render: (record) => {
				return record.profilePicture ? (
					<ImageComponent size={40} imageId={record?.profilePicture} />
				) : (
					<CustomAvatar name={`${record.name} ${record.surname}`} type='initials' />
				);
			},
			width: 90,
			show: true,
		},
		{
			title: 'Name',
			key: 'name',
			render: (record) => {
				return <span>{`${record.name} ${record.surname}`}</span>;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
			width: 200,
		},
		{
			title: 'Email',
			dataIndex: 'email',
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
			width: 175,
		},
		{
			title: 'Phone',
			key: 'phone',
			render: (record) => {
				return <span>{`+(${record.phoneCountryCode}) ${record.phone}`}</span>;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Country',
			key: 'country',
			render: (record) => {
				return record.country ? <span>{`${record.country} `}</span> : <MinusOutlined />;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Rating',
			key: 'rating',
			render: (record) => {
				return record.rating ? (
					<Rate allowHalf disabled defaultValue={record?.rating} />
				) : (
					<Rate allowHalf disabled defaultValue={0} />
				);
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Allow booking decline',
			key: 'autoAccept',
			width: 180,
			align: 'center',
			render: (record) => {
				// a toggle button to change the auto accept status
				return (
					<span>
						<Switch
							checked={record.allowBookingDecline}
							onClick={(value) => handleToggleAllowBookingDecline(value, record)}
						/>
					</span>
				);
			},
			show: true,
		},
		{
			title: 'Application Status',
			key: 'applicationStatus',
			render: (record) => {
				const getStatusBadge = (status) => {
					switch (status) {
						case 'APPROVED':
							return (
								<Badge
									color='#52c41a'
									text={
										<span style={{ color: '#389e0d', fontWeight: 'bold' }}>
											APPROVED
										</span>
									}
								/>
							);
						case 'DENIED_RENEWAL':
							return (
								<Badge
									color='#ff4d4f'
									text={
										<span style={{ color: '#cf1322', fontWeight: 'bold' }}>
											DENIED_RENEWAL
										</span>
									}
								/>
							);
						case 'DENIED':
							return (
								<Badge
									color='#ff4d4f'
									text={
										<span style={{ color: '#cf1322', fontWeight: 'bold' }}>
											DENIED
										</span>
									}
								/>
							);
						case 'PENDING':
							return (
								<Badge
									color='#d9d9d9'
									text={
										<span style={{ color: '#d9d9d9', fontWeight: 'bold' }}>
											PENDING
										</span>
									}
								/>
							);
						case 'PENDING_DOCUMENT_RENEWAL':
							return (
								<Badge
									color='#faad14'
									text={
										<span style={{ color: '#d46b08', fontWeight: 'bold' }}>
											PENDING DOCUMENT RENEWAL
										</span>
									}
								/>
							);
						default:
							return (
								<span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>
									_
								</span>
							);
					}
				};
				const driverApplicationStatus = record.taxiModeWithRole?.find(r => r.role === "DRIVER")?.applicationStatus || null;
				return getStatusBadge(driverApplicationStatus);
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: CheckDriverEnabled()
		},
		{
			title: 'Fleet Operator',
			key: 'fleetOperators',
			render: (record) => {
				const fleet = record.fleetOperators
					? [...record.fleetOperators].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
					: null;
				if (!fleet?.length) return <MinusOutlined />;
				const first = fleet[0];
				const rest = fleet.slice(1);
				return (
					<span style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'nowrap' }}>
						<span style={style.tagsDriver}>{first.name}</span>
						{rest.length > 0 && (
							<Tooltip title={rest.map(f => f.name).join('\n')} overlayStyle={{ whiteSpace: 'pre-line' }}>
								<span style={{ ...style.tagsDriver, cursor: 'default', backgroundColor: '#f0f0f0', color: '#595959' }}>
									+{rest.length}
								</span>
							</Tooltip>
						)}
					</span>
				);
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
			width: 130,
		},
		{
			title: 'Status',
			key: 'active',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record.active ? (
							<div style={style.statusActif}>ACTIVE</div>
						) : (
							<div style={style.statusInactif}>INACTIVE</div>
						)}
					</span>
				);
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			width: 90,
			show: true,
		},

		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButtonWithChangeStatus
					record={record}
					onDelete={() => handleDeleteDriver(record.id, () => { })}
					onEdit={() => handleSelectedDriver(record)}
					onRowClick={() => handleSelectedDriver(record)}
					onChangeStatus={() => handleChangeStatus(record)}
				/>
			),

			show: true,
			width: 100,
		},
	];

	const [search, setSearch] = useState('');
	const [sortBy, setSortBy] = useState('created');
	const [sortDirection, setSortDirection] = useState('DESC');
	const searchTimerRef = useRef(null);
	const [open, setOpen] = useState(false);
	const [driver, setDriver] = useState(null);
	const [isMakingApiCall, setMakingApiCall] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const dispatch = useDispatch();
	const { Drivers } = useSelector((state) => state.drivers);

	const handleToggleAllowBookingDecline = (value, record) => {
		setMakingApiCall(true);
		dispatch(changeDriverAllowBookingDecline({ driverId: record.id, status: value }))
			.unwrap()
			.then(() => {
				message.success('Allow booking decline status updated successfully');
			})
			.catch(() => {
				message.error('Error updating driver');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};
	const fetchAllFlletOperators = () => {
		dispatch(getAllFleetOperators())
			.unwrap()
			.then(() => { })
			.catch(() => {
				message.error('Error getting fleet operators');
			});
	};

	const handleDeleteDriver = (id, callback) => {
		setMakingApiCall(true);
		dispatch(
			deleteDriver({
				driverId: id,
			}),
		)
			.unwrap()
			.then(() => {
				message.success('Driver deleted successfully');
				callback();
			})
			.catch(() => { })
			.finally(() => {
				onClose();
				setMakingApiCall(false);
			});
	};

	// Function to check if any driver documents are expired or driver is denied renewal
	const hasExpiredDocuments = (d) => {
		const today = dayjs();

		// Check if driver status is DENIED_RENEWAL
		if (d.applicationStatus === 'DENIED_RENEWAL') {
			return true;
		}

		// Get expiry dates from driverDocuments array
		const driverDocuments = d.driverDocuments || [];
		const expiryDates = driverDocuments.map((doc) => doc.expiryDate).filter(Boolean); // Remove null/undefined values

		const hasExpired = expiryDates.some((date) => {
			const expiryDate = dayjs(date);
			const isExpired = expiryDate.isBefore(today, 'day');
			return isExpired;
		});

		return hasExpired;
	};

	const handleChangeStatus = async (record) => {
		// Check if driver has DENIED_RENEWAL status
		if (record.applicationStatus === 'DENIED_RENEWAL') {
			message.error(
				'Cannot enable driver. Driver status is "Denied Renewal". Please review the driver\'s application status.',
			);
			return;
		}

		// If trying to enable (activate) a driver, check for expired documents
		if (!record.active) {
			try {
				// Fetch detailed driver information including documents
				const detailedDriver = await dispatch(
					getDriverById({ driverId: record.id }),
				).unwrap();

				if (hasExpiredDocuments(detailedDriver)) {
					message.error(
						'Cannot enable driver. One or more documents have expired. Please ensure all documents are up to date before enabling the driver.',
					);
					return;
				}
			} catch {
				message.error('Failed to validate driver documents. Please try again.');
				return;
			}
		}

		setMakingApiCall(true);
		dispatch(
			changeDriverStatus({
				userId: record.id,
				active: !record.active,
			}),
		)
			.unwrap()
			.then(() => {
				message.success('Driver status updated successfully');
			})
			.catch((e) => {
				const errorMessage = e?.message || 'Error updating user status';
				if (errorMessage === 'DRIVER_SHOULD_UPLOAD_DOCUMENTS_TO_BE_ACTIVATED') {
					message.error('Driver should upload documents to be activated');
				} else {
					message.error(errorMessage);
				}
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const handleRefetchDrivers = () => {
		dispatch(getAllDrivers({ page: currentPage - 1, size: pageSize, search, sortBy, sortDirection }));
	}

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
		setDriver(null);
	};

	const fetchAll = () => {
		setMakingApiCall(true);
		dispatch(
			getAllDrivers({
				page: currentPage - 1,
				size: pageSize,
				search,
				sortBy,
				sortDirection,
			})
		)
			.unwrap()
			.catch(() => {
				message.error('Error fetching drivers');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const sortFieldMap = {
		applicationStatus: 'taxiModeWithRole.applicationStatus',
		fleetOperators: 'fleetOperators.name',
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			const field = sorter.columnKey || sorter.field;
			setSortBy(sortFieldMap[field] || field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('created');
			setSortDirection('DESC');
		}
		setCurrentPage(1);
	};

	useEffect(() => {
		fetchAll();
	}, [currentPage, pageSize, search, sortBy, sortDirection]);

	useEffect(() => {
		if (isActive) {
			fetchAll();
			fetchAllFlletOperators();
		}
	}, [isActive]);

	const handleSelectedDriver = (selectedDriver) => {
		setDriver(selectedDriver);
		showDrawer();
	};

	let driversArray = Object.values(Drivers.driversList);
	driversArray = driversArray.map((item) => {
		return { ...item, key: item.id };
	});
	
	// Filter out DENIED_RENEWAL status from All Drivers (shown in Pending tab)
	driversArray = driversArray.filter((item) => {
		const driverStatus = item.taxiModeWithRole?.find(r => r.role === "DRIVER")?.applicationStatus;
		return driverStatus !== 'DENIED_RENEWAL';
	});

	return (
		<>
			<Card
				style={{
					margin: 16,
					maxHeight: '90%', // Set maximum width
					height: 'auto', // Allow width to be dynamic
				}}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'Drivers',
								},
							]}
						/>
						<Button
							type='default'
							size='small'
							// style={{ margin: '0 8px 8px 0' }}
							onClick={() => fetchAll()}>
							<ReloadOutlined />
						</Button>
					</div>
					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						<Input.Search
							placeholder="Search drivers"
							allowClear
						onSearch={(value) => {
							clearTimeout(searchTimerRef.current);
							setCurrentPage(1);
							setSearch(value);
						}}
						onChange={(e) => {
							clearTimeout(searchTimerRef.current);
							const val = e.target.value;
							searchTimerRef.current = setTimeout(() => {
								setCurrentPage(1);
								setSearch(val);
							}, 400);
						}}
						style={{ margin: '0 8px 8px 0' }}
					/>


						<Button
							type='default'
							style={{ float: 'right', marginBottom: 8 }}
							onClick={showDrawer}>
							Add Driver
						</Button>
					</div>
				</div>
				<CustomTableComponentsPageable
					isMakingApiCall={isMakingApiCall}
					columns={columns.filter((column) => column.show)}
					dataArray={driversArray}
					handleDoubleClickRow={(record) => handleSelectedDriver(record)}
					handleSelectedRow={() => { }}
					onTableChange={handleTableChange}
					pagination={{
						current: currentPage,
						pageSize,
						total: Drivers.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</Card>
			{open && (
				<DrawerDriver
					onClose={onClose}
					open={open}
					driverId={driver?.id}
					handleDeleteDriver={handleDeleteDriver}
					handleRefetchDrivers={handleRefetchDrivers}
				/>
			)}
		</>
	);
};

export default Driver;
